// removed by extract-text-webpack-plugin
module.exports = {"rating":"rating__35BiG","star":"star__2Ppdx"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/Rating/styles.scss
// module id = ./app/scripts/views/App/components/Rating/styles.scss
// module chunks = 1